import { Component, OnInit } from '@angular/core';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-swiper-skills',
    templateUrl: './swiper-skills.component.html',
    styleUrls: ['./swiper-skills.component.scss']
})
export class SwiperSkillsComponent implements OnInit {

    swiperInstance: any;
    isBegin: boolean = true;
    isEnd: boolean = false;

    constructor() { }

    ngOnInit(): void {
    }

    /**
     * When 'Skills on Demand' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onSkillsSwiper(swiper) {

        this.swiperInstance = swiper;

        setTimeout(() => {
            //   swiper.update();
        }, 1500);

    }

    /**
     * Using slidechange to disable / enable the next and previous buttons
     */
    onSlideChange() {

        this.isBegin = this.swiperInstance.isBeginning;
        this.isEnd = this.swiperInstance.isEnd;

    }

    /**
     * Slides to the next image
     */
    gotoNext() {

        this.swiperInstance.slideNext();

    }

    /**
     * Slides to the previous image
     */
    gotoPrevious() {

        this.swiperInstance.slidePrev();

    }

}
